import { DownOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';

interface ToggleButtonProps {
  className?: string;
  /** 是否折叠 */
  folded: boolean;
  /** 折叠文本 */
  foldText?: string;
  /** 展开文本 */
  unfoldText?: string;
  /** 切换回调 */
  onToggle: () => void;
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const { className, folded, onToggle, foldText, unfoldText } = props;

  return (
    <span
      className={cx('text-[12px] text-[#84868C] cursor-pointer', className)}
      onClick={onToggle}
      role="button"
    >
      {folded ? foldText : unfoldText}
      <DownOutlined
        className="ml-1.5 text-[10px]"
        style={{
          transform: folded ? 'rotate(0deg)' : 'rotate(180deg)',
          transition: 'transform 0.2s ease',
        }}
      />
    </span>
  );
};
